import React, { FC, ReactNode, useMemo } from "react";
import { ALIGN, InfoBox, INFOBOX_TYPE } from "@lookiero/aurora";
import { useI18nMessage } from "@lookiero/i18n-react";
import { Text } from "@lookiero/sty-psp-ui";
import { DOMAIN, I18nMessages } from "../../../i18n/i18n";
import { style as fiveItemsDiscountBannerStyle } from "./FiveItemsDiscountBanner.style";

interface FiveItemsDiscountBannerProps {
  readonly fiveItemsDiscount: number;
}
const FiveItemsDiscountBanner: FC<FiveItemsDiscountBannerProps> = ({ fiveItemsDiscount }) => {
  const style = useMemo(() => fiveItemsDiscountBannerStyle(), []);

  const bannerText = useI18nMessage({
    domain: DOMAIN,
    id: I18nMessages.BANNER_DISCOUNT_TEXT,
    values: {
      discount: fiveItemsDiscount.toString(),
      b: (chunks: ReactNode[]) => (
        <Text level={2} style={style.textBold}>
          {chunks}
        </Text>
      ),
    },
  });

  return (
    <InfoBox
      contentAlign={ALIGN.CENTER}
      icon="info"
      testID="five-items-discount-banner"
      text={bannerText}
      type={INFOBOX_TYPE.SQUARED}
    />
  );
};

export { FiveItemsDiscountBanner };
